import { render, staticRenderFns } from "./history.vue?vue&type=template&id=2f600886&scoped=true&"
import script from "./history.vue?vue&type=script&lang=ts&"
export * from "./history.vue?vue&type=script&lang=ts&"
import style0 from "./history.vue?vue&type=style&index=0&id=2f600886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f600886",
  null
  
)

export default component.exports